module.exports = __webpack_public_path__ + "static/media/arrow-down.5dd89cc8.svg";